import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pedagogico',
  templateUrl: './pedagogico.component.html',
  styleUrls: ['./pedagogico.component.css']
})
export class PedagogicoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
